<template>
  <WsUpdate
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    titleKey="last_version.name"
    :customParentData="customParentData"
    :hasCatchVersion="hasCatchVersion"
    :submodelVersionName="submodelVersionName"
    :submodelName="submodelName"
    :customUpdateAction="$_customUpdateAction"
  >
  </WsUpdate>
</template>

<script>
import model from "@/models/change_item_template";
import submodel from "@/models/risk_template";
export default {
  data: () => ({
    modelName: model.modelName,
    submodelName: submodel.modelName,
    submodelVersionName: submodel.versionModelName,
    label: model.label,
    fields: model.fields,
    hasCatchVersion: true,
    customParentData: (parentData) => {
      return {
        area: parentData.area,
      };
    },
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "變因資訊",
              fields: ["last_version"],
              createHideFields: ["last_version"],
              link: {
                btnName: "點此前往新增",
                alertTitle: "確認要前往新增變動評估項目嗎？",
                path: `/risk_template/create`,
              },
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "分類設定",
              fields: [
                "areas",
                "industry_categories",
                "range_type",
                "factories",
                "exclusive_factories"
              ],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              remark: "隱藏的內容將不會顯示於使用者前台介面",
              fields: ["is_active"],
            },
          ],
        },
      ],
    },
  }),
  methods: {
    $_customUpdateAction(modelData) {
      if (modelData.range_type === "exclusive") {
        modelData.factories = []
      }
      if(modelData.range_type === "general") {
        modelData.exclusive_factories = null
      }
    },
  }
};
</script>